import { WsRadioGroup, WsRadioObj } from 'wisestep-base';

import WsAccordion from './WsAccordion';

interface RadioListFilterProps {
  name: string;
  options: WsRadioObj[];
  title: string;
  row?: boolean;
  disabled?: boolean;
  infoText?: string;
  startIcon?: React.ReactElement;
}

const RadioListFilter = ({
  name,
  options,
  title,
  row,
  disabled,
  infoText,
  startIcon,
}: RadioListFilterProps) => (
  <WsAccordion
    title={title}
    disabled={disabled}
    infoText={infoText}
    {...(startIcon && { startIcon: startIcon })}
  >
    <WsRadioGroup name={name} selectArray={options} row={row} />
  </WsAccordion>
);

export default RadioListFilter;
